import { withLoadingTypes as withCargoTypes } from '@ati/hocs';
import OptionsSelector from '@components/options-selector';
import { observer } from 'mobx-react-lite';

import { MobileScreen } from 'components/MobileScreen';
import { useStore } from 'hooks/useStore';

import css from './Mobile.module.css';

const WrappedOptionsSelector = withCargoTypes(OptionsSelector);

const Mobile = () => {
  const {
    dictionaries: { data },
    app: { i18n },
    filter: {
      cargoType: { cargoTypes, setCargoTypes, clearCargoTypes, isDefault },
    },
  } = useStore();

  const actions = {
    second: {
      onClick: clearCargoTypes,
      text: i18n.common.reset,
    },
  };

  const handleChange = (values: string[]) => {
    setCargoTypes(values);
  };

  return (
    <MobileScreen hasBackButton actions={isDefault ? undefined : actions} title={i18n.cargoTypes.label}>
      <WrappedOptionsSelector
        classNames={{ desktopOptionList: css.list }}
        /* @ts-ignore */
        dictionary={data.cargoTypes}
        matchMedia="1px"
        selectedValues={cargoTypes}
        /* @ts-ignore */
        onChange={handleChange}
      />
    </MobileScreen>
  );
};

const connected = observer(Mobile);

export { connected as Mobile };
